import { selectAllParams } from './../router/router.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatient from './patient.reducer';

export const selectPatientState = createFeatureSelector<fromPatient.PatientState>(fromPatient.patientsFeatureKey);

export const selectAllPatients = createSelector(
  selectPatientState,
  fromPatient.selectAll
);

export const selectPatientEntities = createSelector(
  selectPatientState,
  fromPatient.selectEntities
);

export const selectPatientById = (id: string) => createSelector(
  selectPatientEntities,
  pacientEntities => pacientEntities[id] || null
);

export const selectPatient = createSelector(
  selectAllParams,
  selectPatientEntities,
  (params, pacientEntities) => params.patientId ? pacientEntities[params.patientId] : null
);

export const selectPatientId = createSelector(
  selectPatient,
  patient => patient?.id || null
);
